import type { RemovalPricingDto } from './model';

/** 信用点转整数毫点后计算，避免浮点乘法误差。 */
export function calcRemovalMilli(pricing: RemovalPricingDto, duration: number) {
  return (
    Math.round(pricing.credit * 1000) *
    (pricing.unit === 'second' ? Math.trunc(duration) : 1)
  );
}
